const POST_FORMECID = 'fulcrum/containers/Project/HulkRequest/POST_FORMECID'
const UPDATE_LICENSE = 'fulcrum/containers/Project/HulkRequest/UPDATE_LICENSE'
const UPDATE_TEXT = 'fulcrum/containers/Project/HulkRequest/UPDATE_TEXT'
const UPDATE_TOGGLE = 'fulcrum/containers/Project/HulkRequest/UPDATE_TOGGLE'
const UPDATE_MESSAGE = 'fulcrum/containers/Project/HulkRequest/UPDATE_MESSAGE'
const MODULE_NAME = 'fulcrum/containers/Project/HulkRequest/'

const POST_FORMECID_START = MODULE_NAME + 'POST_FORMECID_START'
const POST_FORMECID_SUCCESS = MODULE_NAME + 'POST_FORMECID_SUCCESS'
const POST_FORMECID_ERROR = MODULE_NAME + 'POST_FORMECID_ERROR'


export {
  POST_FORMECID,
  UPDATE_TEXT,
  UPDATE_LICENSE,
  UPDATE_TOGGLE,
  MODULE_NAME,
  UPDATE_MESSAGE,
  POST_FORMECID_START,
  POST_FORMECID_SUCCESS,
  POST_FORMECID_ERROR
}
